import { generateUUID } from "@/utils";
import windowsSizes from "@/config/window-sizes";

const state = {
  desktop: [],
  overheadLayout: [],
  minimizedWindows: [],
  isLeftPanelCollapsed: true,
  navPanelLinks: [{ name: "desktop", path: "/desktop", inMenu: true }],
  leftPanelLinks: {},
  syncPanels: [],
  windowsConfigs: [],
  sizesConfig: {}
};

const actions = {};

const mutations = {
  ADD_NEW_OVERHEAD_WINDOW(state, options) {
    const sizesConfig = state.sizesConfig ? state.sizesConfig : windowsSizes;
    const overlay = state.overheadLayout;
    const founded = overlay.find(item => item.childComponent === options.title);
    let objectFounded = false;
    if (options.title === "object-info")
      objectFounded = overlay.find(item => item.id === options.id);
    if (founded && options.title !== "object-info") return;
    if (objectFounded) {
      if (objectFounded["isMinimized"]) {
        const index = state.minimizedWindows.indexOf(objectFounded);
        state.minimizedWindows.splice(index, 1);
        state.overheadLayout.find(i => i.id === options.id).isMinimized = false;
        return;
      }
      return;
    }
    const lastWindow = state.overheadLayout[state.overheadLayout.length - 1];
    const i = overlay.length ? (parseInt(lastWindow.i) + 1).toString() : "0";
    const config = sizesConfig[options.type]
      ? sizesConfig[options.type].overheadDesktop
      : sizesConfig.default.overheadDesktop;
    const isSingleMode = sizesConfig[options.type]
      ? sizesConfig[options.type].singleMode
      : false;
    if (isSingleMode) {
      const item = state.desktop
        .concat(state.overheadLayout)
        .find(item => item.childComponent === options.type);
      if (item) return;
    }
    const item = {
      x: options.x !== undefined ? options.x : config.x,
      y: options.y !== undefined ? options.y : config.y,
      w: options.w || config.w,
      h: options.h || config.h,
      i: i,
      minw: config.minw,
      minh: config.minh,
      maxw: config.maxw,
      maxh: config.maxh,
      childComponent: options.title,
      windowId: options.windowId ? options.windowId : generateUUID(),
      id: options.id ? options.id : undefined,
      sourcename: options.sourcename ? options.sourcename : undefined,
      datatype: options.datatype ? options.datatype : undefined,
      profile: options.profile ? options.profile : undefined,
      isMinimized: false,
      isMaximized: false
    };
    const clientHeight = document.body.clientHeight;
    if (item.h > clientHeight) item.h = clientHeight - 80;
    if (options.tabs) {
      item.tabs = options.tabs;
    }
    if (!state.isLeftPanelCollapsed && options.type === "settings") {
      item.x = 206;
    }
    if (!state.isLeftPanelCollapsed && options.type === "Layers") {
      item.x = 249;
    }
    if (item.y < 0) item.y = 5;
    state.overheadLayout.push(item);
  },
  MINIMIZE_OVERHEAD_WINDOW(state, i) {
    const index = state.overheadLayout.findIndex(item => item.i === i);
    let item = state.overheadLayout[index];
    if (item.isMaximized) {
      item.isMaximized = false;
      item.h = item.prevH;
      item.w = item.prevW;
      item.x = item.prevX;
      item.y = item.prevY;
    } else {
      state.minimizedWindows.push(item);
      item.isMinimized = true;
    }
  },
  REMOVE_OVERHEAD_WINDOW_FROM_MINIMIZED(state, item) {
    const index = state.minimizedWindows.indexOf(item);
    state.minimizedWindows.splice(index, 1);
    item.isMinimized = false;
  },
  MAXIMIZE_OVERHEAD_WINDOW(state, i) {
    let item = state.overheadLayout.find(item => item.i === i);
    if (!item.isMaximized) {
      if (item.isMinimized) {
        item.isMinimized = false;
        item.h = item.prevH;
        item.w = item.prevW;
        item.x = item.prevX;
        item.y = item.prevY;
      } else {
        item.prevH = item.h;
        item.prevW = item.w;
        item.h = window.innerHeight;
        item.w = window.innerWidth;
        item.x = 0;
        item.y = 0;
        item.isMaximized = true;
      }
    } else {
      item.h = item.prevH;
      item.w = item.prevW;
      item.x = item.prevX;
      item.y = item.prevY;
      item.isMaximized = false;
    }
  },
  CLOSE_OVERHEAD_WINDOW(state, i) {
    state.overheadLayout = state.overheadLayout.filter(item => item.i !== i);
  },
  SET_WINDOW_CONFIG(state, payload) {
    const index = state.windowsConfigs.findIndex(
      item => item.windowId === payload.windowId
    );
    if (index === -1) {
      state.windowsConfigs.push(payload);
    } else {
      state.windowsConfigs[index] = payload;
    }
  },
  DELETE_WINDOW_CONFIG(state, payload) {
    state.windowsConfigs = state.windowsConfigs.filter(
      item => item.windowId !== payload
    );
  },
  SAVE_ITEM_SIZES(state, payload) {
    state.sizesConfig[payload.childComponent].overheadDesktop = {
      x: payload.x,
      y: payload.y,
      w: payload.w,
      h: payload.h
    };
  }
};

export default {
  state,
  actions,
  mutations
};
